// components/gameroom/styles.js
// SECURITY NOTE: Primarily a static styling/constants file. The one piece of logic (the Icon
// component below) renders a hardcoded Flaticon CDN URL set and a caller-supplied icon `name`
// into a CSS class string, not into HTML, so it carries no injection risk on its own.
// ⚡ SEVERITY: ⚪ INFO - 0%

export const S = {
  page: {
    backgroundColor: "#0a0e27",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Poppins,sans-serif",
    backgroundImage: "linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1629 100%)",
  },
  header: {
    backgroundColor: "rgba(15, 23, 42, 0.7)",
    backdropFilter: "blur(12px)",
    borderBottom: "1px solid rgba(51, 65, 85, 0.3)",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  headerInner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 1.5rem",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
  },
  headerCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 1.5rem",
    position: "relative",
  },
  main: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem 1rem",
    width: "100%",
    backgroundColor: "transparent",
  },
  card: {
    backgroundColor: "rgba(30, 41, 59, 0.4)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(51, 65, 85, 0.3)",
    borderRadius: "1.2rem",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.1)",
    padding: "1.5rem",
    width: "100%",
  },
  cardLg: {
    backgroundColor: "rgba(30, 41, 59, 0.35)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(51, 65, 85, 0.3)",
    borderRadius: "1.25rem",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25), inset 0 1px 1px rgba(255, 255, 255, 0.08)",
    padding: "1.75rem",
    width: "100%",
  },
  insetBox: {
    backgroundColor: "rgba(15, 23, 42, 0.4)",
    border: "1px solid rgba(51, 65, 85, 0.2)",
    borderRadius: "0.875rem",
    padding: "0.875rem 1.25rem",
  },
  pill: (color) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: "0.35rem",
    backgroundColor: `${color}15`,
    border: `1.5px solid ${color}40`,
    borderRadius: "9999px",
    padding: "0.35rem 0.75rem",
    fontFamily: "Poppins,sans-serif",
    fontSize: "0.65rem",
    fontWeight: 700,
    color: color,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    backdropFilter: "blur(4px)",
  }),
  label: {
    fontFamily: "Poppins,sans-serif",
    fontSize: "0.65rem",
    fontWeight: 700,
    color: "#cbd5e1",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
  sectionTitle: {
    fontFamily: "Poppins,sans-serif",
    fontSize: "0.8rem",
    fontWeight: 700,
    color: "#f1f5f9",
    letterSpacing: "0.04em",
    margin: "0 0 1rem",
  },
  footer: {
    backgroundColor: "rgba(15, 23, 42, 0.5)",
    backdropFilter: "blur(8px)",
    borderTop: "1px solid rgba(51, 65, 85, 0.2)",
    padding: "1rem",
    textAlign: "center",
  },
  footerText: {
    color: "#94a3b8",
    fontSize: "0.7rem",
    margin: 0,
    fontFamily: "Poppins,sans-serif",
    letterSpacing: "0.04em",
  },
  btn: (bg) => ({
    backgroundColor: bg,
    color: "white",
    border: "none",
    padding: "0.75rem 1.5rem",
    borderRadius: "0.8rem",
    fontFamily: "Poppins,sans-serif",
    fontWeight: 700,
    fontSize: "0.9rem",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    width: "100%",
    textAlign: "center",
    letterSpacing: "0.02em",
    transition: "all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease",
    boxShadow: `0 4px 15px ${bg}40`,
  }),
  btnOutline: (color) => ({
    backgroundColor: `${color}08`,
    color: color,
    border: `1.5px solid ${color}50`,
    padding: "0.75rem 1.5rem",
    borderRadius: "0.8rem",
    fontFamily: "Poppins,sans-serif",
    fontWeight: 700,
    fontSize: "0.9rem",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    width: "100%",
    transition: "all 0.25s ease",
    backdropFilter: "blur(4px)",
  }),
  ghostBtn: {
    background: "rgba(51, 65, 85, 0.1)",
    border: "1px solid rgba(51, 65, 85, 0.2)",
    borderRadius: "0.65rem",
    padding: "0.4rem 0.8rem",
    cursor: "pointer",
    fontFamily: "Poppins,sans-serif",
    fontSize: "0.65rem",
    fontWeight: 700,
    color: "#cbd5e1",
    display: "flex",
    alignItems: "center",
    gap: "0.35rem",
    transition: "all 0.2s ease",
  },
  alertBox: (bg, border) => ({
    backgroundColor: bg,
    border: `1px solid ${border}`,
    borderRadius: "0.875rem",
    padding: "1rem",
    marginBottom: "0.75rem",
    backdropFilter: "blur(4px)",
  }),
  statusBox: (type) => ({
    padding: "0.75rem 1rem",
    borderRadius: "0.875rem",
    textAlign: "center",
    fontSize: "0.8rem",
    fontWeight: 600,
    fontFamily: "Poppins,sans-serif",
    backgroundColor:
      type === "error" ? "rgba(239, 68, 68, 0.1)" :
      type === "success" ? "rgba(34, 197, 94, 0.1)" :
      type === "warning" ? "rgba(245, 158, 11, 0.1)" :
      "rgba(59, 130, 246, 0.1)",
    color:
      type === "error" ? "#ff6b6b" :
      type === "success" ? "#22c55e" :
      type === "warning" ? "#f59e0b" :
      "#60a5fa",
    border: `1.5px solid ${
      type === "error" ? "rgba(239, 68, 68, 0.3)" :
      type === "success" ? "rgba(34, 197, 94, 0.3)" :
      type === "warning" ? "rgba(245, 158, 11, 0.3)" :
      "rgba(59, 130, 246, 0.3)"
    }`,
    backdropFilter: "blur(4px)",
  }),
  input: {
    width: "100%",
    border: "1.5px solid rgba(51, 65, 85, 0.3)",
    borderRadius: "0.8rem",
    padding: "0.8rem 1rem",
    fontSize: "0.9rem",
    fontFamily: "Poppins,sans-serif",
    color: "#f1f5f9",
    outline: "none",
    transition: "all 0.2s ease",
    boxSizing: "border-box",
    backgroundColor: "rgba(15, 23, 42, 0.3)",
    backdropFilter: "blur(4px)",
  },
  inputLabel: {
    fontFamily: "Poppins,sans-serif",
    fontSize: "0.75rem",
    fontWeight: 700,
    color: "#cbd5e1",
    letterSpacing: "0.04em",
    display: "block",
    marginBottom: "0.5rem",
  },
  iconBox: (bg) => ({
    backgroundColor: bg,
    borderRadius: "0.85rem",
    width: "2.75rem",
    height: "2.75rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    border: "1px solid rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(4px)",
  }),
  iconBoxSm: (bg) => ({
    backgroundColor: bg,
    borderRadius: "50%",
    width: "2.25rem",
    height: "2.25rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    border: "1px solid rgba(255, 255, 255, 0.1)",
  }),
  modal: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.65)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
    padding: "1rem",
    backdropFilter: "blur(8px)",
  },
  modalCard: {
    backgroundColor: "rgba(30, 41, 59, 0.5)",
    borderRadius: "1.25rem",
    width: "100%",
    maxWidth: "28rem",
    boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4), inset 0 1px 1px rgba(255, 255, 255, 0.1)",
    overflow: "hidden",
    border: "1px solid rgba(51, 65, 85, 0.3)",
    backdropFilter: "blur(10px)",
  },
  modalHeader: (bg) => ({
    backgroundColor: bg || "rgba(51, 65, 85, 0.15)",
    padding: "1.25rem 1.5rem",
    borderBottom: `1.5px solid rgba(51, 65, 85, 0.2)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }),
  modalBody: {
    padding: "1.5rem",
  },
  modalFooter: {
    padding: "1rem 1.5rem",
    backgroundColor: "rgba(51, 65, 85, 0.08)",
    borderTop: "1px solid rgba(51, 65, 85, 0.2)",
    display: "flex",
    gap: "0.75rem",
  },
  progressBar: (color, pct) => ({
    width: `${pct}%`,
    height: "100%",
    backgroundColor: color,
    borderRadius: "9999px",
    transition: "width 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
    boxShadow: `0 0 20px ${color}60`,
  }),
  progressTrack: {
    width: "100%",
    backgroundColor: "rgba(51, 65, 85, 0.2)",
    borderRadius: "9999px",
    height: "0.375rem",
    overflow: "hidden",
    border: "0.5px solid rgba(51, 65, 85, 0.3)",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  col: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
  },
  spinner: (color) => ({
    width: "1.25rem",
    height: "1.25rem",
    border: `2.5px solid ${color}20`,
    borderTopColor: color,
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    display: "inline-block",
    flexShrink: 0,
  }),
};

export const COLORS = {
  green: "#22c55e",
  greenDark: "#16a34a",
  red: "#ff6b6b",
  redDark: "#ff5252",
  blue: "#60a5fa",
  blueDark: "#3b82f6",
  amber: "#f59e0b",
  amberDark: "#d97706",
  purple: "#a78bfa",
  sky: "#0ea5e9",
  gray: "#64748b",
  darkText: "#f1f5f9",
  midText: "#cbd5e1",
  lightText: "#94a3b8",
  border: "rgba(51, 65, 85, 0.3)",
  bg: "rgba(15, 23, 42, 0.3)",
};

export const MOVE_IMAGES = {
  rock: "https://cdn.jsdelivr.net/gh/HamzaRSP/MOVES@main/R.png",
  paper: "https://cdn.jsdelivr.net/gh/HamzaRSP/MOVES@main/P.png",
  scissors: "https://cdn.jsdelivr.net/gh/HamzaRSP/MOVES@main/S.png",
};

export const MOVE_COLORS = {
  rock: "#dc2626",
  paper: "#2563eb",
  scissors: "#16a34a",
};

export const MOVE_LABELS = {
  rock: "Rock",
  paper: "Paper",
  scissors: "Scissors",
};

// Icon component - Now works with all Flaticon icons loaded via index.html
export function Icon({ name, size = "1rem", color, style = {} }) {
  return (
    <i
      className={`fi fi-${name}`}
      style={{ fontSize: size, color, lineHeight: 1, display: "inline-flex", alignItems: "center", ...style }}
    />
  );
}

// GLOBAL_STYLES - Now only contains animations and global CSS (no icon imports)
export const GLOBAL_STYLES = `
  *, *::before, *::after { box-sizing: border-box; }

  @keyframes spin      { to { transform: rotate(360deg); } }
  @keyframes popIn     { 0%{transform:scale(0.85);opacity:0} 70%{transform:scale(1.1)} 100%{transform:scale(1);opacity:1} }
  @keyframes slideUp   { from{transform:translateY(12px);opacity:0} to{transform:translateY(0);opacity:1} }
  @keyframes slideDown { from{transform:translateY(-12px);opacity:0} to{transform:translateY(0);opacity:1} }
  @keyframes fadeIn    { from{opacity:0} to{opacity:1} }
  @keyframes pulse     { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.4;transform:scale(0.98)} }
  @keyframes timerBeat { 0%,100%{transform:scale(1)} 50%{transform:scale(1.15)} }
  @keyframes shimmer   { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
  @keyframes slideInRight { from{transform:translateX(100%);opacity:0} to{transform:translateX(0);opacity:1} }
  @keyframes glow      { 0%,100%{box-shadow:0 0 10px rgba(34,197,94,0)} 50%{box-shadow:0 0 20px rgba(34,197,94,0.4)} }

  .move-btn  { transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, filter 0.25s ease !important; }
  .move-btn:hover:not(:disabled) { transform: translateY(-4px) scale(1.08) !important; box-shadow: 0 12px 24px rgba(0,0,0,0.25) !important; filter: brightness(1.1); }
  .move-btn:active:not(:disabled) { transform: scale(0.96) !important; }
  .throw-btn { transition: filter 0.25s ease, transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease !important; }
  .throw-btn:hover:not(:disabled) { filter: brightness(1.12) !important; transform: translateY(-2px) !important; }
  .throw-btn:active:not(:disabled) { transform: scale(0.97) !important; }
  .ghost-btn { transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease !important; }
  .ghost-btn:hover { background: rgba(51, 65, 85, 0.15) !important; border-color: rgba(51, 65, 85, 0.4) !important; color: #f1f5f9 !important; }
  .rps-btn { transition: opacity 0.2s ease, transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease !important; }
  .rps-btn:hover:not(:disabled) { opacity: 0.95 !important; transform: translateY(-2px) !important; }
  .rps-btn:active:not(:disabled) { transform: scale(0.98) !important; }
  .rps-btn:disabled { opacity: 0.4 !important; cursor: not-allowed !important; }
  .rps-input:focus { border-color: #60a5fa !important; box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.2) !important; }
  .rps-link { color: #60a5fa; text-decoration: none; font-weight: 600; transition: color 0.2s, opacity 0.2s; }
  .rps-link:hover { color: #93c5fd; opacity: 0.85; }
`;